import React from "react";

class FixedBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    if (window.scrollY > this.props.showTop) {
      this.setState({ display: true });
    }else{
      this.setState({ display: false });
    }
  }

  render() {
    return (
      <div className={`fixed-btn${this.state.display ? "" : " none"}`}>
      {this.props.children}
      </div>
    );
  }
}

export default FixedBtn;
